module.exports = __webpack_public_path__ + "static/regtech-md-1aa0c4238670aac64a4a4cb119318637.jpg";